import { Brand, type Node, type Trigger, TriggerType } from '@keyvue/one-api-client';
import type { Router } from 'vue-router';

interface Link {
    type: string
    label: string
    link: string
}

export function getUnsubscribeSpecialLink(): Link {
    return {
        type: 'Flow',
        label: 'Uitschrijflink',
        link: '{{ unsubscribeLink }}',
    };
}

export function getSpecialLinksForBrand(brand: Brand): Link[] {
    const links: Link[] = [];
    const additionalUrlLabels = {
        sales: 'Verkoop',
        purchase: 'Aankoop',
        valuation: 'Taxatie',
        mortgage: 'Hypotheek',
        contact: 'Contact',
    };

    if (brand.websiteUrl) {
        links.push({
            type: 'Merk',
            label: 'Website',
            link: brand.websiteUrl,
        });
    }

    Object.entries(brand.additionalUrls).forEach(([key, url]) => {
        if (!additionalUrlLabels[key]) {
            return;
        }

        links.push({
            type: 'Merk',
            label: additionalUrlLabels[key],
            link: url,
        });
    });

    return links;
}

export function getSpecialLinksForPages(node: Node, router: Router): Link[] {
    return node.pages.map((page) => {
        const pageUrl = router.resolve({
            name: 'page',
            params: {
                pageId: page.id.value,
            },
        });

        const absolutePageUrl = new URL(pageUrl.href, window.location.origin);

        return {
            type: 'Pagina',
            label: page.title,
            link: absolutePageUrl.href,
        };
    });
}

export function getSpecialLinksForTrigger(trigger: Trigger): Link[] {
    switch (trigger.type.value) {
        case TriggerType.REALWORKS_AGENDA.value: return getSpecialLinksForAgendaTrigger();
        case TriggerType.REALWORKS_TAAK.value: return getSpecialLinksForTaakTrigger();
        case TriggerType.REALWORKS_RELATIE.value: return getSpecialLinksForRelatieTrigger();
        case TriggerType.REALWORKS_KENMERK.value: return getSpecialLinksForKenmerkTrigger();
        case TriggerType.REALWORKS_BIRTHDAY.value: return getSpecialLinksForBirthdayTrigger();
        default: return [];
    }
}

function getSpecialLinksForAgendaTrigger(): Link[] {
    return [];
}

function getSpecialLinksForTaakTrigger(): Link[] {
    return [];
}

function getSpecialLinksForRelatieTrigger(): Link[] {
    return [];
}

function getSpecialLinksForKenmerkTrigger(): Link[] {
    return [];
}

function getSpecialLinksForBirthdayTrigger(): Link[] {
    return [];
}
